<template>
  <div>
    <div :style="{borderBottom: (exportModeul.length-1 !== index) ? '1px dashed #d9d9d9' : 'none', marginBottom: '10px'}" v-for="(item, index) in exportModeul">
      <a-row>
        <a-col :span="8" style="margin-bottom: 10px">
          <span class="titleModule">分类模块</span>
          <span class="moduleName">{{ item.moduleName }}</span>
        </a-col>
      </a-row>
      <a-row>
        <div class="field">
          <span  v-for="item2 in item.fieldList">{{ item2 }}</span>
        </div>
      </a-row>
    </div>
  </div>
</template>

<script>
import exportModeul from './assetExportModule.json'
export default {
  name: 'moduleBox',
  data() {
    return {
      exportModeul
    }
  }
}
</script>

<style lang="less" scoped>
.titleModule {
  color: #B3B3B3;
  font-size: 14px;
}
.moduleName {
  margin-left: 10px;
  font-size: 14px;
}
.field {
  padding-bottom: 5px;
  span {
    display: inline-block;
    padding: 5px;
    background-color: rgba(23, 145, 255, 0.1);
    border-radius: 8px;
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
</style>